import { pushEcommerceGa4DataLayer } from "./dataLayer";
import { getAnalyticsUserData, getCookie } from "./helpers";

export type EcommerceItem = {
  item_id: string;
  item_name: string;
  price: number;
  quantity: number;
  discount: number;
  affiliation: string;
  item_brand: string;
  item_category: string;
  item_category2: string;
  item_category3: string;
  item_variant: string;
  index?: number;
  promotion_name?: string;
};

export type AddToCartDataLayerParams = {
  value: number;
  items: EcommerceItem[];
  addtocart_method: string;
  subscription: string;
  subscription_frequency: string | null;
};

export type SelectItemParams = {
  itemListName: string;
  itemListId: string;
  items: EcommerceItem[];
};

export const pushViewPromotionDataLayer = (promotion_name: string): void => {
  pushEcommerceGa4DataLayer({
    eventName: "view_promotion",
    ecommerce: { promotion_name }
  });
};

export const pushSelectPromotionDataLayer = (promotion_name: string): void => {
  pushEcommerceGa4DataLayer({
    eventName: "select_promotion",
    ecommerce: { promotion_name }
  });
};

export const pushSelectItemDataLayer = ({
  itemListName,
  itemListId,
  items
}: SelectItemParams): void => {
  pushEcommerceGa4DataLayer({
    eventName: "select_item",
    ecommerce: {
      item_list_name: itemListName,
      item_list_id: itemListId,
      items
    }
  });
};

export const pushAddToCartDataLayer = ({
  value,
  items,
  addtocart_method,
  subscription,
  subscription_frequency
}: AddToCartDataLayerParams): void => {
  const promotion_name = getCookie("lastSelectPromotionName");
  const itemsWithPromotion = items.map((item) =>
    promotion_name ? { ...item, promotion_name } : item
  );

  pushEcommerceGa4DataLayer({
    eventName: "add_to_cart",
    ecommerce: {
      currency: "BRL",
      value,
      items: itemsWithPromotion
    },
    userData: {
      ...getAnalyticsUserData(),
      addtocart_method,
      subscription,
      subscription_frequency
    }
  });
};
